(function () {
  if (window.__hypdCartInit) return;
  window.__hypdCartInit = 1;
window.HypdCart = window.HypdCart || {};
(function (C) {
  function isBundleLine(item) {
    if (!item || !item.properties) return false;
    var p = item.properties;
    return p._hypd_bundle === '1' || p._hypd_bundle === 1 || p['_hypd_bundle'] === '1' || p['_hypd_bundle'] === 1;
  }
  function visibleQty(cart) {
    if (!cart || !cart.items || !cart.items.length) return 0;
    var n = 0;
    for (var i = 0; i < cart.items.length; i++) if (!isBundleLine(cart.items[i])) n += cart.items[i].quantity || 0;
    return n;
  }
  function countHtml(n) {
    if (n < 1) return '';
    return '<div class="cart-count' + (n > 9 ? ' cart-count--ellipse' : '') + '"><span aria-hidden="true">' + n + '</span></div>';
  }
  function updateHeader(cart) {
    var n = visibleQty(cart);
    var html = countHtml(n);
    document.querySelectorAll('#CartCount, #StickyCartCount').forEach(function (el) { el.innerHTML = html; });
    var nc = document.getElementById('NewCartCount');
    if (nc) nc.innerHTML = html;
  }
  var BUNDLE_ATTR_KEYS = ['bundle_source', 'hypd_bundle_checkout'];

  function fetchCart() {
    if (!window.routes || !window.routes.cart_url) return Promise.resolve({ items: [] });
    return fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }
  function setCartAttributes(attrs) {
    if (!window.routes || !window.routes.cart_url) return Promise.resolve();
    return fetch(window.routes.cart_url + '/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ attributes: attrs }),
    });
  }
  function hasBundleCartAttributes(cart) {
    if (!cart || !cart.attributes) return false;
    var a = cart.attributes;
    return a.bundle_source === 'bundle_page' || a.hypd_bundle_checkout === '1' || a.hypd_bundle_checkout === 1;
  }
  function cartHasBundleLines(cart) {
    if (!cart || !cart.items || !cart.items.length) return false;
    for (var i = 0; i < cart.items.length; i++) if (isBundleLine(cart.items[i])) return true;
    return false;
  }
  function clearBundleCartAttributes() {
    var empty = {};
    BUNDLE_ATTR_KEYS.forEach(function (k) { empty[k] = ''; });
    return setCartAttributes(empty);
  }
  function setBundleCartAttributes(extra) {
    var attrs = { bundle_source: 'bundle_page', hypd_bundle_checkout: '1' };
    if (extra && typeof extra === 'object') {
      Object.keys(extra).forEach(function (k) { attrs[k] = extra[k]; });
    }
    return setCartAttributes(attrs);
  }
  function shouldKeepBundleAttributes(cart) {
    return cartHasBundleLines(cart) && isBundleOnly(cart);
  }
  function syncBundleAttributes(cart) {
    if (!cart) return Promise.resolve(cart);
    if (hasBundleCartAttributes(cart) && !shouldKeepBundleAttributes(cart)) {
      return clearBundleCartAttributes().then(fetchCart);
    }
    return Promise.resolve(cart);
  }
  function isBundleOnly(cart) {
    if (!cart || !cart.items || !cart.items.length) return false;
    for (var i = 0; i < cart.items.length; i++) if (!isBundleLine(cart.items[i])) return false;
    return true;
  }
  function clearBundle() {
    if (!window.routes || !window.routes.cart_url) return Promise.resolve();
    return fetchCart()
      .then(function (cart) {
        if (!isBundleOnly(cart)) return cart;
        return fetch(window.routes.cart_url + '/clear.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        })
          .then(clearBundleCartAttributes)
          .then(function () { return { item_count: 0, items: [], attributes: {} }; });
      })
      .then(syncBundleAttributes)
      .then(function (cart) { updateHeader(cart); return cart; })
      .catch(function () {});
  }
  function isBundlePage() {
    return document.body.classList.contains('template-page-bundle') || !!document.querySelector('[data-bundle-picker]') || /\/pages\/bundle(?:\/|\?|$)/.test(location.pathname);
  }
  C.isBundleLine = isBundleLine;
  C.visibleQty = visibleQty;
  C.updateHeader = updateHeader;
  C.fetch = fetchCart;
  C.isBundleOnly = isBundleOnly;
  C.clearBundle = clearBundle;
  C.isBundlePage = isBundlePage;
  C.setBundleCartAttributes = setBundleCartAttributes;
  C.clearBundleCartAttributes = clearBundleCartAttributes;
  C.syncBundleAttributes = syncBundleAttributes;
  C.refreshHeader = function () {
    return fetchCart().then(syncBundleAttributes).then(updateHeader).catch(function () {});
  };
  window.hypdVisibleCartQuantity = visibleQty;
  window.hypdUpdateHeaderCartCount = updateHeader;
  window.hypdClearBundleCart = clearBundle;

  function clearBundleCouponSession() {
    var code = window.HypdCartConfig && window.HypdCartConfig.bundleDiscountCode;
    if (!code) return Promise.resolve();
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || (window.routes && window.routes.root_url) || '/';
    var clearUrl = root.replace(/\/?$/, '/') + 'discount/';
    return fetch(clearUrl, { method: 'GET', credentials: 'same-origin', redirect: 'manual' }).catch(function () {});
  }
  function hookCartFetch() {
    if (window.__hypdCartFetchHook) return;
    window.__hypdCartFetchHook = true;
    var native = window.fetch.bind(window);
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var isCartApi = /\/cart\/(add|change|update)\.js/.test(url);
      var isAdd = /\/cart\/add\.js/.test(url);
      var res = native(input, init);
      if (isAdd && !isBundlePage()) {
        res = res.then(function (response) {
          if (!response.ok) return response;
          return clearBundleCouponSession().then(function () { return response; }).catch(function () { return response; });
        });
      }
      if (!isCartApi || isBundlePage()) return res;
      return res.then(function (response) {
        if (!response.ok) return response;
        return fetchCart()
          .then(syncBundleAttributes)
          .then(function () { return response; })
          .catch(function () { return response; });
      });
    };
  }

  hookCartFetch();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', C.refreshHeader);
  else C.refreshHeader();
  window.addEventListener('pageshow', C.refreshHeader);
})(window.HypdCart);
})();
